import { EllipseResize } from "@logicflow/extension";
import {
  getShapeStyleFuction,
  getTextStyleFunction,
} from "../getShapeStyleUtil";

// 项目
class ProjectModel extends EllipseResize.model {
  initNodeData(data) {
    super.initNodeData(data);
    this.rx = 70;
    this.ry = 70;
  }

  setToBottom() {
    this.zIndex = 0;
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    style.fill = "#22314F";
    style.stroke = "#22314F";
    const properties = this.getProperties();
    return getShapeStyleFuction(style, properties);
  }

  getTextStyle() {
    const style = super.getTextStyle();
    style.color = "#FFFFFF";
    const properties = this.getProperties();
    return getTextStyleFunction(style, properties);
  }
}

export default {
  type: "pro-project-circle",
  view: EllipseResize.view,
  model: ProjectModel,
};
